import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BookingsComponent } from 'src/app/shared/bookings/bookings.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { WorkspaceApprovalComponent } from './workspace-approval/workspace-approval.component';
import { WorkspaceMembersComponent } from './workspace-members/workspace-members.component';


const routes: Routes = [
  {
    path: 'sign-up', component: SignInComponent
  },
  {
    path: 'sign-up/:origin', component: SignInComponent,
  },
  {
    path: 'home', loadChildren: () => import('./homepage/homepage.module').then(m => m.HomepageModule),
  },
  {
    path: 'profile', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'about', loadChildren: () => import('../../shared/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'bookings', component: BookingsComponent
  },
  {
    path: 'workspace/approval', component: WorkspaceApprovalComponent
  },
  {
    path: 'workspace/members/:workspaceid', component: WorkspaceMembersComponent
  },
  {
    path: '', loadChildren: () => import('./guest/guest.module').then(m => m.GuestModule),
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomemoduleRoutingModule { }
